import CloseIcon from '@mui/icons-material/Close';
import NotifIcon from '@mui/icons-material/NotificationsActive';
import { Alert, AlertTitle, Box, IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import { useI18n } from '../../hooks/useI18n';
import { GlassButton } from '../GlassButton/GlassButton';

const STORAGE_KEY = 'push-prompt-dismissed';

export interface PushNotificationPromptProps {
  entityType: string;
  onEnable: () => Promise<void>;
  pushEnabled: boolean;
}

export function PushNotificationPrompt({ entityType, onEnable, pushEnabled }: PushNotificationPromptProps) {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (pushEnabled) return;
    if (localStorage.getItem(STORAGE_KEY)) return;
    if (typeof Notification !== 'undefined' && Notification.permission !== 'default') return;
    setVisible(true);
  }, [pushEnabled]);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  const enable = async () => {
    await onEnable();
    setVisible(false);
  };

  return (
    <Alert
      severity="info"
      icon={<NotifIcon />}
      action={
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <GlassButton size="small" onClick={enable}>
            {t('common.enable')}
          </GlassButton>
          <IconButton size="small" onClick={dismiss}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      }
      sx={{ mb: 2 }}
    >
      <AlertTitle>{t('notification.pushPromptTitle')}</AlertTitle>
      {t('notification.pushPromptBody', { entityType })}
    </Alert>
  );
}
